$(document).ready(function () {

  /**************************************************
   * loading screen
   **************************************************/
  //$('.loading-screen').fadeOut();
  /*$(window).on('beforeunload', function() {
    $('.loading-screen').fadeIn();
  })*/

  $.ajaxSetup({
    headers: {
      "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
    },
  });

  /* only for homepage */
  if($('.home').length > 0)
  {
    stickyHeader();
  }

  initMobileMenu();
  initHomeBanner();
  initHomeSecondContentSliding();

  new SmoothScroll('a[href*="#"]');

  initPageScroll();

  $('.unwrap > li').unwrap();
});

$(window).on('load scroll resize', function () {
  var hh  = $('header').innerHeight();
  var ww = $(window).width();

  $('.header-push').css({'height': hh});
  if(ww <= 991){
    $('.banner, .home-banner-slide').css({'height': 'calc(100vh - ' + hh +'px)'});
  }else{
    $('.banner, .home-banner-slide').css({'height': 'calc(100vh)'});
  }
});

$(window).on('scroll', initPageScroll);

/* only for homepage */
if($('.home').length > 0)
{
  $(window).on('scroll', stickyHeader);
}

function initPageScroll()
{
  if($(window).scrollTop() > $('.home-banner').innerHeight()) {
    $('.back-to-bottom-icon').hide();
    $('.back-to-top-icon').show();
  }else{
    $('.back-to-bottom-icon').show();
    $('.back-to-top-icon').hide();
  }
}

window.returnConfirm = function (e) {
  return confirm('Are you sure?');
}

window.captchaCallback = function(response) {
  $(".g-recaptcha").val(response);
};

window.initMobileMenu = function(){
  if($("#navigationMobileMenu").length > 0)
  {
    var menu = new MmenuLight($("#navigationMobileMenu").get(0));

    /*mmenu.create("(max-width: 1200px)");

     mmenu.init("current");*/
    var navigator = menu.navigation({
        // selectedClass: 'Selected',
        // slidingSubmenus: true,
        theme: 'light',
        // title: 'Menu'
    });

    var drawer = menu.offcanvas({
        position: 'right'
    });

    $('#mobileMenuBtn').on("click", function(ev) {
        $('#navigationMobileMenu').css("display", "block");
        drawer.open();

        ev.preventDefault();
        ev.stopPropagation();
    });
  }
}

function stickyHeader() {
  if ($(window).scrollTop() > $(".navigation-wrapper").innerHeight()) {
    $(".navigation-wrapper").addClass("sticky");
  } else {
    $(".navigation-wrapper").removeClass("sticky");
  }
}

function initHomeBanner() {
  if($('.home-banner').length > 0)
  {
    $('.home-banner').slick({
      lazyLoad: 'ondemand',
      dots: true,
      arrows: false,
      infinite: true,
      speed: 2000,
      autoplay: true,
      autoplaySpeed: 2000,
      slidesToShow: 1,
      slidesToScroll: 1,
      asNavFor: '.home-banner-slide-container',
    });
  }
  if($('.home-banner-slide-container').length > 0)
  {
    $('.home-banner-slide-container').slick({
      lazyLoad: 'ondemand',
      dots: false,
      arrows: false,
      infinite: true,
      speed: 2000,
      autoplay: true,
      autoplaySpeed: 2000,
      slidesToShow: 1,
      slidesToScroll: 1,
      asNavFor: '.home-banner',
    });
  }
}

function initHomeSecondContentSliding()
{
  if($('.home-content-second-box').length > 0)
  {
    $('.home-content-second-box').slick({
      lazyLoad: 'ondemand',
      dots: false,
      arrows: true,
      infinite: true,
      speed: 300,
      autoplay: true,
      autoplaySpeed: 2000,
      slidesToShow: 1,
      slidesToScroll: 1,
      prevArrow: $('.home-content-second-wrapper .slick-prev'),
      nextArrow: $('.home-content-second-wrapper .slick-next'),
    });
  }
}

window.setInputFilter = function (textbox, inputFilter) {
  ["input", "keydown", "keyup", "mousedown", "mouseup", "select", "contextmenu", "drop"].forEach(function(event) {
    textbox.addEventListener(event, function() {
      if (inputFilter(this.value)) {
        this.oldValue = this.value;
        this.oldSelectionStart = this.selectionStart;
        this.oldSelectionEnd = this.selectionEnd;
      } else if (this.hasOwnProperty("oldValue")) {
        this.value = this.oldValue;
        this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
      } else {
        this.value = "";
      }
    });
  });
}